'use client';

import { useState } from 'react';
import { EmailBanner } from '@highereducation/hen-ui';
import { prefixHenSitePath } from '@highereducation/request-context';

const SUBSCRIBE_URL = prefixHenSitePath('/api/hen/lists/subscribe');

function noticeSubscriptionError(error: unknown): void {
  const nr = (window as unknown as { newrelic?: { noticeError?: Function } })
    .newrelic;
  if (error instanceof Error) {
    nr?.noticeError?.(error, {
      component: 'EmailBanner',
      action: 'subscription',
    });
    return;
  }
  nr?.noticeError?.(new Error('Email subscription failed'), {
    component: 'EmailBanner',
    action: 'subscription',
  });
}

export function EmailBannerClient() {
  const [status, setStatus] = useState<
    'idle' | 'loading' | 'success' | 'error'
  >('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (email: string) => {
    setStatus('loading');
    setErrorMessage('');

    try {
      const response = await fetch(SUBSCRIBE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData = (await response.json()) as { message?: string };
        throw new Error(errorData.message || 'Failed to subscribe');
      }

      setStatus('success');
    } catch (error) {
      setStatus('error');
      setErrorMessage(
        error instanceof Error
          ? error.message
          : 'Something went wrong. Please try again.',
      );
      noticeSubscriptionError(error);
    }
  };

  return (
    <EmailBanner
      status={status}
      errorMessage={errorMessage}
      onSubmit={handleSubmit}
    />
  );
}
